/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/
import React, { } from 'react';
import {
    Grid,
    FormControl,
    Button,
    FormHelperText,
    Typography} from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-mui';
import { makeStyles } from 'tss-react/mui';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { getUserInfo } from '../../../../../../store/reducers/user/userAction';
import { patchUserMe } from '../../../../../../services/user/UserController';

const useStyles = makeStyles()(theme => ({
    formInput: {
        ...theme.typography.customInput,
        marginBottom: '10px !important'
    },
    avatar: {
        margin: 'auto',
        width: '150px!important',
        height: '150px!important'
    },
}));

const UserUpdateForm = ({ toggleEdit }) => {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);


    return (
             <Grid container spacing={4}>
                <Grid item xs={12} md={12}>

                    <Typography>Profile Information</Typography>
                </Grid>
                <Grid item xs={12} md={12}>

                    <Formik
                        initialValues={{
                            username: user.username || '',
                            email: user.email || '',
                        }}
                        validationSchema={Yup.object().shape({
                            username: Yup.string(),
                            email: Yup.string().email(),
                        })}
                        onSubmit={async (values, { setSubmitting }) => {
                            try {
                                await patchUserMe({
                                    email: values.email,
                                });
                                toast.info('User information updated successfully');
                                await dispatch(getUserInfo()).unwrap();
                                toggleEdit(false);
                            } catch (error) {
                                toast.warning('Something went wrong, please try again later');
                            } finally {
                                setSubmitting(false);
                            }
                        }}
                    >
                        {({ values, handleBlur, handleChange, touched, errors }) => (
                            <Form>
                                <Grid container spacing={4}>


                                    {/* User Information Fields */}
                                    <Grid item xs={12} md={6}>
                                        <Grid container spacing={4}>
                                            {['username', 'email'].map((field, index) => (
                                                <Grid key={index} item xs={12} sm={6}>
                                                    <FormControl fullWidth className={classes.formInput}>
                                                        <Field
                                                            id={`outlined-${field}`}
                                                            type="text"
                                                            value={values[field]}
                                                            variant="outlined"
                                                            name={field}
                                                            label={field.charAt(0).toUpperCase() + field.slice(1)}
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                            fullWidth
                                                            component={TextField}
                                                        />
                                                        {touched[field] && errors[field] && (
                                                            <FormHelperText error>
                                                                {errors[field]}
                                                            </FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* Form Actions */}
                                <Grid container spacing={2} style={{ marginTop: '20px' }}>
                                    <Grid item>
                                        <Button type="submit" variant="contained" color="primary">Save</Button>
                                    </Grid>
                                    <Grid item>
                                        <Button variant="outlined" onClick={() => toggleEdit(false)}>Cancel</Button>
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                </Grid>
            </Grid>
     );
};

export default UserUpdateForm;
